import React from "react";
import { Outlet } from "react-router-dom";
const LeadsIndex = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default LeadsIndex;
